import Parse from 'parse'

class HealthCheckApi {
  async checkParseHealth(): Promise<any> {
    return Parse.Cloud.run('Misc_healthCheck')
  }
}

export default new HealthCheckApi()
